export const items = [
  { text: "5551 Windhaven Pkwy, Suite 200", link: null, external: false },
  { text: "Lewisville, TX 75056", link: null, external: false },
  { text: "TEL: 972-480-0888", link: null, external: false },
  { text: "FAX: 972-480-8884", link: null, external: false },
  { text: "service@trastarusa.com", link: null, external: false },
];

export const header = { text: "Trastar Inc.", link: "/", external: false };
